<template>
  <div class="slo-modal-view" v-bind="$attrs" v-on="$listeners">
    <slot />
    <transition name="modal">
      <router-view v-if="routeModal" />
      <component v-if="sloModal" global :is="params.name" :params="params" />
    </transition>
  </div>
</template>

<script>
import DesignSpecAddToProject from '../../js/marketplace/views/global/DesignSpecAddToProject.vue';
import DesignSpecCreateProject from '../../js/marketplace/views/global/DesignSpecCreateProject.vue';

export default {
  name: 'SloModalView',
  components: {
    DesignSpecAddToProject,
    DesignSpecCreateProject
  },
  mounted() {
    this.$root.$on('slo-modal:show', params => {
      this.sloModal = true;
      this.params = params;
    });
    this.$root.$on('slo-modal:hide', () => {
      this.sloModal = false;
      this.params = {};
    });
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(newVal) {
        this.routeModal = newVal && newVal.meta && newVal.meta.modal;
      }
    }
  },
  data() {
    return {
      params: {},
      sloModal: false,
      routeModal: false
    };
  }
};
</script>

<style lang="scss">
@import '../../scss/variables';

.slo-modal-frame {
  display: flex;
  flex-direction: column;
  background: white;
  flex: 1;
  max-height: 80vh;
}

.modal-enter-active {
  animation: noop 350ms linear;
}

.modal-enter-active::after {
  animation: backdrop-fade 350ms cubic-bezier(0.215, 0.61, 0.355, 1);
}

.modal-enter-active .slo-modal-frame {
  animation: modal-enter 275ms 75ms cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.modal-leave-active {
  animation: noop 200ms linear;
}

.modal-leave-active::after {
  animation: backdrop-fade 150ms 50ms reverse cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.modal-leave-active .slo-modal-frame {
  animation: modal-enter 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94) both reverse;
}

@keyframes noop {
  from {
    opacity: 1;
  }
  to {
    opacity: 1;
  }
}

@keyframes backdrop-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modal-enter {
  from {
    opacity: 0;
    transform: translateY(30px) translateZ(1px);
  }
  to {
    opacity: 1;
    transform: translateY(0) translateZ(1px);
  }
}
</style>
